import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../ui/theme/colors';

export const useSettingsEditorPanelStyles = makeStyles(() => ({
  paperCompact: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '32px',
    marginBottom: '32px'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '32px',
    minHeight: '100%'
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    borderBottom: `1px solid ${Colors.lightGray}`,
    marginBottom: '16px',
    minHeight: '72px',
    padding: '16px 24px'
  },
  titleText: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  titleSubText: {
    marginLeft: '8px',
    display: 'flex',
    alignItems: 'center'
  },
  saveButton: {
    width: '150px',
    height: '40px',
    color: '#ffffff',
    backgroundColor: Colors.collectedGreen,
    marginLeft: '8px'
  }
}));
